// @mui/material components
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';

const AdminNavbarLinks = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ position: 'relative', mr: 2 }}>
        <IconButton sx={{ mr: 1 }}>
          <SearchIcon />
        </IconButton>
        <InputBase
          placeholder="Search…"
          sx={{ width: 120 }}
        />
      </Box>
    </Box>
  );
};

export default AdminNavbarLinks;
